/* eslint-disable no-console */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConfiguration } from 'app/core/models/app-configuration.model';
/**
 * Confirm Result component
 * @description Angular utility component. Show Success/Failure dialog based on input from parent component
 */
@Component({
  selector: 'ap-modal-dossier-result',
  templateUrl: './dossier-result.component.html',
})
export class DossierResultComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() extraResultClass?: string;
  @Input() btnText?: string;
  @Input() btnVisible?: boolean;
  @Input() btnClose?: string;
  @Input() isSuccess: boolean;

  @Output() onSubmit = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal, public appConfig: AppConfiguration) {
    this.isSuccess = false;
  }

  /**
   * After user require to close the dialog, return control to parent component
   */
  confirmSubmit(): void {
    this.onSubmit.next();
  }

  closeModal(): void {
    this.activeModal.dismiss('dismiss');
  }
}
